import { Button, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useCallback } from 'react';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { YOU_TUBE_URL_REGEX, extractYoutubeId, isYoutubeUrl } from '../../utils/youtubeHelper';

const useStyles = makeStyles()({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  btn: {
    marginLeft: 8,
  },
});

export interface ValidatedYoutubeInputProps {
  onChange: (text: string, isValid: boolean) => void;
  onConfirm: (url: string) => void;
  startAdornment?: JSX.Element;
}

const ValidatedYoutubeInput: React.FC<ValidatedYoutubeInputProps> = ({
  onChange,
  onConfirm,
  startAdornment,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const validationSchema = Yup.object({
    url: Yup.string()
      .matches(YOU_TUBE_URL_REGEX, t('home.input.url_not_valid'))
      .required(t('home.input.youtube_url')),
  });

  const formik = useFormik({
    initialValues: {
      url: '',
    },
    validationSchema,
    onSubmit: (values) => onConfirm(`https://youtube.com/watch?v=${extractYoutubeId(values.url)}`),
  });

  const handleOnChangeUrlText = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formik.handleChange(e);
      onChange(e.target.value, isYoutubeUrl(e.target.value));
    },
    [formik.handleChange, onChange],
  );

  return (
    <form className={classes.root} onSubmit={formik.handleSubmit}>
      <TextField
        fullWidth
        name="url"
        value={formik.values.url}
        onChange={handleOnChangeUrlText}
        label={t('home.input.youtube_url')}
        error={Boolean(formik.errors.url)}
        helperText={formik.errors.url}
        type="search"
        variant="outlined"
        InputProps={{
          startAdornment,
        }}
      />
      <Button
        className={classes.btn}
        disabled={!!formik.errors.url || !formik.values.url}
        variant="contained"
        size="small"
        type="submit"
      >
        {t('home.youtube_dialog.submit')}
      </Button>
    </form>
  );
};

export default ValidatedYoutubeInput;
